import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';
import zhTranslations from './locales/zh.json';
import nlTranslations from './locales/nl.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import esTranslations from './locales/es.json';
import ruTranslations from './locales/ru.json';
import ptTranslations from './locales/pt.json';
import hiTranslations from './locales/hi.json';

const resources = {
  en: { translation: enTranslations },
  ar: { translation: arTranslations },
  zh: { translation: zhTranslations },
  nl: { translation: nlTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  es: { translation: esTranslations },
  ru: { translation: ruTranslations },
  pt: { translation: ptTranslations },
  hi: { translation: hiTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  });

export default i18n;

